/*
 *
 * PatientDataPage constants
 *
 */
import {getPractice} from "utils/practiceStorage";

/**
 * Get patient
 */
export const GET_PATIENT = "app/PatientDataPage/GET_PATIENT";
export const GET_PATIENT_FAILED = "app/PatientDataPage/GET_PATIENT_FAILED";
export const GET_PATIENT_SUCCESS = "app/PatientDataPage/GET_PATIENT_SUCCESS";

/**
 * Update patient
 */
export const UPDATE_PATIENT = "app/PatientDataPage/UPDATE_PATIENT";
export const UPDATE_PATIENT_FAILED =
  "app/PatientDataPage/UPDATE_PATIENT_FAILED";
export const UPDATE_PATIENT_SUCCESS =
  "app/PatientDataPage/UPDATE_PATIENT_SUCCESS";

/**
 * Get planned treatments
 */
export const GET_PLANNED_TREATMENTS =
  "app/PatientDataPage/GET_PLANNED_TREATMENTS";
export const GET_PLANNED_TREATMENTS_FAILED =
  "app/PatientDataPage/GET_PLANNED_TREATMENTS_FAILED ";
export const GET_PLANNED_TREATMENTS_SUCCESS =
  "app/PatientDataPage/GET_PLANNED_TREATMENTS_SUCCESS";

/**
 * Get active product plan
 */
export const GET_ACTIVE_PRODUCT_PLAN =
  "app/PatientDataPage/GET_ACTIVE_PRODUCTPLAN";
export const GET_ACTIVE_PRODUCT_PLAN_FAILED =
  "app/PatientDataPage/GET_ACTIVE_PRODUCTPLAN_FAILED ";
export const GET_ACTIVE_PRODUCT_PLAN_SUCCESS =
  "app/PatientDataPage/GET_ACTIVE_PRODUCTPLAN_SUCCESS";

/**
 * Get treatment history
 */
export const GET_TREATMENT_HISTORY =
  "app/PatientDataPage/GET_TREATMENT_HISTORY";
export const GET_TREATMENT_HISTORY_FAILED =
  "app/PatientDataPage/GET_TREATMENT_HISTORY_FAILED";
export const GET_TREATMENT_HISTORY_SUCCESS =
  "app/PatientDataPage/GET_TREATMENT_HISTORY_SUCCESS";

/**
 * Delete Patient
 */
export const DELETE_PATIENT = "app/PatientDataPage/DELETE_PATIENT";
export const DELETE_PATIENT_FAILED =
  "app/PatientDataPage/DELETE_PATIENT_FAILED";
export const DELETE_PATIENT_SUCCESS =
  "app/PatientDataPage/DELETE_PATIENT_SUCCESS";
export const RESET_DELETE_PATIENT_ERROR_MESSAGE =
  "app/PatientDataPage/RESET_DELETE_PATIENT_ERROR_MESSAGE";

/**
 * Close treatmentPlan
 */
export const CLOSE_TREATMENTPLAN = "app/PatientDataPage/CLOSE_TREATMENTPLAN";
export const CLOSE_TREATMENTPLAN_FAILED =
  "app/PatientDataPage/CLOSE_TREATMENTPLAN_FAILED ";
export const CLOSE_TREATMENTPLAN_SUCCESS =
  "app/PatientDataPage/CLOSE_TREATMENTPLAN_SUCCESS";

/**
 * Close productPlan
 */
export const CLOSE_PRODUCTPLAN = "app/PatientDataPage/CLOSE_PRODUCTPLAN";
export const CLOSE_PRODUCTPLAN_FAILED =
  "app/PatientDataPage/CLOSE_PRODUCTPLAN_FAILED ";
export const CLOSE_PRODUCTPLAN_SUCCESS =
  "app/PatientDataPage/CLOSE_PRODUCTPLAN_SUCCESS";


/**
 * Other
 */
export const SOFT_RESET = "app/PatientDataPage/SOFT_RESET";
export const HARD_RESET = "app/PatientDataPage/HARD_RESET";
export const DEFAULT_ACTION = "app/PatientDataPage/DEFAULT_ACTION";

/**
 * Urls
 */
export function GET_TREATMENT_HISTORY_URL(patientId) {
  const practiceId = getPractice().id;
  return `/practices/${practiceId}/patient/${patientId}/plannedTreatments?history=true`;
}

export function GET_PLANNED_TREATMENTS_URL(patientId) {
  const practiceId = getPractice().id;
  return `/practices/${practiceId}/patient/${patientId}/treatmentPlans/active`;
}

export function GET_ACTIVE_PRODUCTPLAN_URL(patientId) {
  const practiceId = getPractice().id;
  return `/practices/${practiceId}/patient/${patientId}/productPlans/active`;
}

export function UPDATE_PATIENT_URL() {
  return `/practices/${getPractice().id}/patients`;
}

export function PATIENT_URL(patientId) {
  return `/practices/${getPractice().id}/patients/${patientId}`;
}

export function DELETE_PATIENT_URL() {
  return `/practices/${getPractice().id}/patients`;
}

export function CLOSE_TREATMENTPLAN_URL(treatmentPlanId) {
  const practiceId = getPractice().id;
  return `/practices/${practiceId}/patient/treatmentPlans/${treatmentPlanId}/close`;
}

export function CLOSE_PRODUCTPLAN_URL(productPlanId) {
  const practiceId = getPractice().id;
  return `/practices/${practiceId}/patient/productPlans/${productPlanId}/close`;
}


export const GET_MESSAGE_DETAILS = "app/PatientDataPage/GET_MESSAGE_DETAILS";
export const GET_MESSAGE_DETAILS_SUCCESS =
  "app/PatientDataPage/GET_MESSAGE_DETAILS_SUCCESS";
export const GET_MESSAGE_DETAILS_ERROR =
  "app/PatientDataPage/GET_MESSAGE_DETAILS_ERROR";

export const CLOSE_MESSAGE = "app/PatientDataPage/CLOSE_MESSAGE";
export const CLOSE_MESSAGE_SUCCESS =
  "app/PatientDataPage/CLOSE_MESSAGE_SUCCESS";
export const CLOSE_MESSAGE_ERROR = "app/PatientDataPage/CLOSE_MESSAGE_ERROR";

export const GET_MESSAGES = "app/PatientDataPage/GET_MESSAGES";
export const GET_MESSAGES_SUCCESS = "app/PatientDataPage/GET_MESSAGES_SUCCESS";
export const GET_MESSAGES_ERROR = "app/PatientDataPage/GET_MESSAGES_ERROR";

export const SET_CURRENT_PAGE = "app/PatientDataPage/SET_CURRENT_PAGE";

export const SEND_ORDER_REMAKE_REQUEST =
  "app/PatientDataPage/SEND_ORDER_REMAKE_REQUEST";
export const SEND_ORDER_REMAKE_REQUEST_SUCCESS =
  "app/PatientDataPage/SEND_ORDER_REMAKE_REQUEST_SUCCESS";
export const SEND_ORDER_REMAKE_REQUEST_ERROR =
  "app/PatientDataPage/SEND_ORDER_REMAKE_REQUEST_ERROR";
export const RESET_ORDER_REMAKE_REQUEST =
  "app/PatientDataPage/RESET_ORDER_REMAKE_REQUEST";

export const SEND_TREATMENT_REFITTING_REQUEST =
  "app/PatientDataPage/SEND_TREATMENT_REFITTING";
export const SEND_TREATMENT_REFITTING_REQUEST_SUCCESS =
  "app/PatientDataPage/SEND_TREATMENT_REFITTING_SUCCESS";
export const SEND_TREATMENT_REFITTING_REQUEST_ERROR =
  "app/PatientDataPage/SEND_TREATMENT_REFITTING_ERROR";
export const RESET_SEND_TREATMENT_REFITTING_REQUEST =
  "app/PatientDataPage/RESET_SEND_TREATMENT_REFITTING_REQUEST";
